(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stg-homepage-v2"] && !Shopify.designMode) return;
  try {
    
  function initStgHome(root) {
    if (!root || root.dataset.stgReady === 'true') return;
    root.dataset.stgReady = 'true';
    const buttons = root.querySelectorAll('[data-stg-material]');
    const cta = root.querySelector('[data-stg-material-cta]');
    const ctaPrefix = root.dataset.stgShopPrefix || 'Shop';
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const material = button.dataset.stgMaterial;
        const label = button.dataset.label;
        root.classList.remove('stg-home--canvas', 'stg-home--metal', 'stg-home--acrylic');
        root.classList.add('stg-home--' + material);
        buttons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        if (cta) {
          cta.href = button.dataset.url;
          cta.innerHTML = ctaPrefix + ' ' + label + ' <span aria-hidden="true">→</span>';
        }
      });
    });
  }
  document.querySelectorAll('[data-stg-home]').forEach(initStgHome);
  document.addEventListener('shopify:section:load', (event) => initStgHome(event.target.querySelector('[data-stg-home]')));

  } catch(e) { console.error(e); }
})();
})();
